import React from 'react'
import { EVENTO } from '../dados/evento'

/**
 * Conteúdo do termo de uso de imagem e voz.
 *
 * COMPONENTE, e não texto duplicado: ele aparece em dois lugares — na página
 * `/termos-de-uso-de-imagem/` (que continua existindo, porque o aceite precisa
 * de um endereço permanente e citável) e no modal do formulário, aberto sem
 * tirar a pessoa da inscrição. Duas cópias do mesmo texto jurídico é o tipo de
 * duplicação que só é descoberta quando as duas já divergiram.
 */
export default function TermosImagem() {
  return (
    <div className="termos">
      <p>
        Ao finalizar a minha inscrição e selecionar a opção "Li e aceito os termos", eu
        autorizo expressamente a{' '}
        <strong>APRESENTA.ME TECNOLOGIA E GESTÃO PARA IMOBILIÁRIAS LTDA</strong>, inscrita no
        CNPJ sob o nº <strong>37.456.158/0001-80</strong>, com sede em Rio do Sul/SC, a
        utilizar a minha imagem e voz coletadas durante o evento{' '}
        <span className="realce">{EVENTO.nome}</span>, a realizar-se no dia{' '}
        {EVENTO.dataLegivel} de 2026, na cidade de Blumenau, SC, conforme as condições
        abaixo:
      </p>

      <h3>Captação e uso</h3>
      <p>
        Autorizo o registro e a fixação da minha imagem e voz em fotografias, vídeos e áudios
        gravados durante o evento, conduzidos pela equipe organizadora e colaboradores
        parceiros.
      </p>

      <h3>Finalidade</h3>
      <p>
        Os registros serão utilizados para fins de divulgação do evento, publicidade
        institucional, materiais de marketing, publicações em redes sociais (Instagram,
        Facebook, LinkedIn, YouTube) e site oficial da organização.
      </p>

      <h3>Gratuidade</h3>
      <p>
        Declaro que esta autorização é concedida de forma totalmente gratuita, sem que me
        caiba qualquer direito a remuneração, indenização ou direitos autorais.
      </p>

      <h3>Prazo e território</h3>
      <p>
        Esta autorização é válida por prazo indeterminado, sem limitação territorial, e está
        em total conformidade com as diretrizes da Lei Geral de Proteção de Dados (LGPD).
      </p>
    </div>
  )
}
